// extracted by css-extract-rspack-plugin
var _1 = "_79akhuXpIex8NbYgUJkddA--";
export { _1 as "wrapper" }
